export function pluralize({
  count,
  noun,
  pluralNoun = noun + "s",
  includeNumber = true,
}: {
  count: number;
  noun: string;
  pluralNoun?: string;
  includeNumber?: boolean;
}) {
  const label = `${count !== 1 ? pluralNoun : noun}`;
  return includeNumber ? `${count} ${label}` : label;
}
